import { LangSwitchPill } from "@/components/LangSwitchPill";
import { createFileRoute, Link } from "@tanstack/react-router";
import { Sparkles, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/partner/register")({
  head: () => ({
    meta: [
      { title: "Become A Partner — What Finland" },
      { name: "description", content: "Partner with What Finland to reach travellers exploring your city. Talk to our team to get listed." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: PartnerRegisterInvitePage,
});

function PartnerRegisterInvitePage() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-lg max-w-lg w-full p-8">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-slate-500 font-semibold">
          <Sparkles className="h-4 w-4" /> Partner Program
        </div>
        <h1 className="mt-3 text-2xl sm:text-3xl font-semibold text-slate-900">Partner With What Finland</h1>
        <LangSwitchPill className="mt-3" />
        <p className="mt-3 text-slate-600">
          Partner accounts are created by our team after we send you a contract to sign. Once you accept the e-sign contract, we'll email you a private onboarding link.
        </p>
        <p className="mt-3 text-slate-600 text-sm">
          Interested in becoming a partner? Reach out to our team and we'll get in touch. Already onboarded? Sign in to your Partner Portal below.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <a
            href="mailto:partners@whatfinland.com?subject=Partner%20Inquiry"
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 text-white font-semibold px-5 py-3 hover:bg-slate-800"
          >
            Contact Our Team <ArrowRight className="h-4 w-4" />
          </a>
          <Link
            to={"/partner/login" as never}
            className="flex-1 inline-flex items-center justify-center rounded-2xl border border-slate-200 text-slate-700 font-medium px-5 py-3 hover:bg-slate-100"
          >
            Partner Login
          </Link>
        </div>
      </div>
    </div>
  );
}

